<template>
    <div>
        <div class="commonSearch bottom" ref="commonSearchRef">
            <el-form class="el-form el-form--inline" style="margin-top: 10px;margin-bottom: 10px">
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="报修单号：">
                            <el-input v-model="form.repaircode" placeholder="模糊匹配" style="width: 180px"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="学生校区：">
                            <el-select v-model="form.region" clearable placeholder="请选择" style="width: 180px">
                                <el-option v-for="item in xqqys" :key="item.id" :label="item.name" :value="item.code">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="故障类型：">
                            <el-select v-model="form.faulttype" clearable placeholder="请选择" style="width: 180px">
                                <el-option v-for="item in gzlxs" :key="item.id" :label="item.name" :value="item.code"> </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-button type="primary" @click="initData()">查询</el-button>
                        <el-button type="primary" plain @click="form = {}">清空</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </div>

        <div class="commonTable">
            <el-table :data="returndata" ref="datas" :height="tabHeight" size="medium" v-loading="loading" element-loading-text="拼命加载中" :header-cell-style="{background: '#FAFAFA', color: '#000000', borderRight: '1px solid #fff'}">
                <el-table-column prop="repaircode" label="报修单号" min-width="130"> </el-table-column>
                <el-table-column prop="regionName" label="学生校区" min-width="80"> </el-table-column>
                <el-table-column prop="faulttypeName" label="故障类型" min-width="120"> </el-table-column>
                <el-table-column v-if="IfAdmin" prop="repersonnel" label="接单人员" min-width="120"> </el-table-column>
                <el-table-column label="是否完成" min-width="80">
                    <template slot-scope="scope">
                        <span style="color:red" v-if="scope.row.tstatus==100402">未完成</span>
                        <span v-else>已完成</span>
                    </template>
                </el-table-column>
                <el-table-column prop="feedbacktext" label="反馈描述" min-width="150"> </el-table-column>
                <el-table-column prop="createdate" label="反馈时间" min-width="150"> </el-table-column>

                <el-table-column label="操作" min-width="120">
                    <template slot-scope="scope">
                        <span class="caozuo" @click="toOrderView(scope.row)">明细</span>
                        <span class="caozuo" @click="completed(scope.row.orderid)" v-if="scope.row.tstatus==100402">&emsp;|&emsp;完成</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="commonPage" align="right">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="cur_page" :page-sizes="[5, 10, 15, 30]" layout="total, sizes, prev, pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
    </div>
</template>

<script>
import TabResize from "@/utils/TabResizeEx.js";
import SettingApi from "@/api/setting.js";
import FaultApi from "@/api/fault.js";

export default {
    mixins: [TabResize],
    components: {},

    data () {
        return {
            form: {
                repaircode: "",
                region: "",
                faulttype: "",
                status: "",
                selectdate: ""
            },
            orderid: "",
            options: [],
            loading: true,
            cur_page: 1,
            per_page: "",
            totalCount: 0,
            csCount: 0,
            returndata: [],
            returndata2: [],
            tablestatus: "pzxx",
            IfAdmin: false,
            activeName: "first",
            gzlxs: [], //故障类型
            xqqys: [] //校区
        };
    },
    mounted: function () {
        if (this.$constant.GET_USER().userName == "admin") {
            this.IfAdmin = true;
        }
        this.initData();

        this.findOptions("1002", "gzlxs");
        this.findOptions("1003", "xqqys");
    },

    methods: {
        completed (id) {
            let param = {
                orderid: id,
                status: '100404'
            }
            FaultApi.getClass()
                .updateStatusByOrderid(param)
                .then((resp) => {
                    if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                        this.initData();
                    } else {
                        this.$message.error(resp.data.msg);
                        this.loading = false;
                        return false;
                    }
                }).catch((err) => {
                    this.loading = false;
                    this.$message.error(err);
                    return false;
                });
        },

        findOptions (code, key) {
            SettingApi.getClass()
                .Findcode(code)
                .then((resp) => {
                    if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                        this[key] = resp.data.data;
                        if(key == "xqqys"){
                            for(let i=0; i<this[key].length; i++){
                                    if(this[key][i].code == '100304'){
                                        this[key].splice(i, 1)
                                    }
                                 }
                        }
                    } else {
                        this.$message.error(resp.data.msg);
                        return false;
                    }
                }).catch((err) => {
                    this.$message.error(err);
                    return false;
                });
        },

        toOrderView (row) {
            this.$router.push({
                name: "OrderView",
                params: { row },
            });
        },

        //报修单反馈列表
        initData (id) {
            this.returndata = [];
            let param = {
                repaircode: this.form.repaircode,
                region: this.form.region,
                faulttype: this.form.faulttype,
                pageNum: this.cur_page,
                pageSize: this.per_page
            };

            FaultApi.getClass()
                .findEvaluatfeedback(param)
                .then((resp) => {
                    if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                        this.totalCount = resp.data.data.totalElements;
                        let data = resp.data.data.data;
                        if (data != null) {
                            this.returndata = data;
                        }
                        this.loading = false;
                    } else {
                        this.$message.error(resp.data.msg);
                        this.loading = false;
                        return false;
                    }
                }).catch((err) => {
                    this.$message.error(err);
                    this.loading = false;
                    return false;
                });
        },

        //切换每页显示多条
        handleSizeChange (val) {
            this.per_page = val;
            this.cur_page = 1;
            this.loading = true;
            this.initData();
        },
        // 切换显示第几页
        handleCurrentChange (val) {
            this.cur_page = val;
            this.loading = true;
            this.initData();
        }
    }
};
</script>

<style lang="stylus" scoped>
.top {
    margin-top: 10px;
    margin-bottom: 20px;
    text-align: left;
    font-size: 18px;
    width: 90%;
    color: #F8F8FF;
    height: 30px;
    background-color: #3D84FF;
}

.bottom {
    // width: 90%;
    // height: 100%
}

// .tabs{
// border-bottom-width: 0px !important;
// }
.caozuo {
    color: #3D84FF;
    cursor: pointer;
}

/deep/.el-button--small {
    margin-left: 20px;
}

.span-box {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .btn-bell-badge {
        width: 26px;
        height: 18px;
        margin-left: 5px;
        line-height: 18px;
        border-radius: 15px;
        background: #f56c6c;

        .num {
            display: block;
            width: 100%;
            text-align: center;
            font-size: 12px;
            color: #fff;
        }
    }
}
</style>